import styled from 'styled-components'
import logo from '../../images/logo.png';

export const FooterContainer = styled.div `
  height: 180px;
`

export const Inline = styled.div `
  font-family: Catamaran;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px;
  letter-spacing: 1px;
  margin-top: 40px;
  left: 20px;
  height: 120px;
  @media (max-width: 500px) {
    height: 60px;
  }
`

export const FooterMenu = styled.div `
@media (max-width: 500px) {
  text-align: center;
  height: 60px;
  width: 200px;
  margin: 0 auto;
  margin-bottom: 10px;
  margin-top: 25px;
}
`

export const Hover = styled.div `
  padding-left: 15px;
  &:hover {
    color: darkgrey;
    cursor: pointer;
  }
`

export const WappenLogo = styled.div `
width:${props => props.size}px;
height:${props => props.size}px;
background:url(${logo}) center center no-repeat;
background-size: ${props => props.size*0.9}px;

@media (max-width: 500px) {
 width: 80px;
 height: 80px;
 background:url(${logo}) center center no-repeat;
 background-size: 60px;
}
`
WappenLogo.defaultProps = {
    size: 100
}

export const TextSpace = styled.div `
  padding-left: 20px;
`


// WEBPACK FOOTER //
// /src/components/layout/FooterStyle.js